export default {
  companyUrl: 'https://dev-next-www.lwtears.com',
  pliUrl: 'https://dev-next-pli.lwtears.com',
  digitalProductSupportUrl: 'https://dev-next-api.lwtears.com/contact-us/digital-product-support',
  digitalAssetsUrl: 'https://a-z-educator-content-dev-next.s3.amazonaws.com',
};
